import Sale from "../../../database/entities/sales/sale.entity";
import { PAYMENT_TYPE } from "../../../types/payment";

function differenceTwoDates(start: any, end: any) {
  const diffTime = Math.abs(end - start);
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function computeSalesStore(storesData: any, sales: Sale[]) {
  const end = new Date();
  end.setHours(23, 59, 59, 0);

  sales.forEach(sale => {
    const saleDate = sale.created_at.toDate();
    const differenceDate = differenceTwoDates(saleDate, end);
    if (differenceDate <= 28 && storesData[sale.storeId]) {
      let effectiveValue = sale.value;
      if (sale.payment_type === PAYMENT_TYPE.COURTESY) {
        effectiveValue = 0;
      }
      storesData[sale.storeId].data[28 - differenceDate] += effectiveValue;
    }
  });
}